<div *ngIf="!hideProviders" class="provider-section">
  <h2>Providers at {{locationName}}</h2>
  <div class="provider-card-container" [ngClass]="providerCardCss">
    <div *ngFor="let p of suggestedProviderCards">
      <fal-provider-card
        [provider]="p"
        [locationName]="locationName"
        [locationId]="locationId"
        (navigateFADProvider)="handleProviderNavigateFAD($event)"
      ></fal-provider-card>
    </div>
  </div>
  <strong *ngIf="!noLinkWithProvider" class="provider-link" (click)="fadLocationNavigate()">
    <a>See all providers at this location</a>
  </strong>
  <div class="button-container pagination">
    <ng-container *ngIf="isSliderRequired">
      <dhcl-pagination [totalPages]="totalPages" [activePage]="pageIndex" (pagerClicked)="getPaginatorData($event)"> </dhcl-pagination>
    </ng-container>
  </div>
</div>
<div class="more-provider" *ngIf="hideProviders">
  <h2>Providers</h2>
  <div>
    <strong class="provider-link" (click)="fadLocationNavigate()">
      <a>See all providers at this location</a>
    </strong>
  </div>
</div>
